export default {
  market: {
    id: 'bo_sellers-opportunities-pricing-filters-market',
    defaultMessage: 'Market',
  },
  categoryId: {
    id: 'bo_sellers-opportunities-pricing-filters-category_id',
    defaultMessage: 'Item category',
  },
  sku: {
    id: 'bo_sellers-opportunities-pricing-filters-sku',
    defaultMessage: 'SKU',
  },
  priceDifference: {
    id: 'bo_sellers-opportunities-pricing-filters-price_difference',
    defaultMessage: 'Price difference',
  },
  priceDifferenceType: {
    id: 'bo_sellers-opportunities-pricing-filters-price_difference_type',
    defaultMessage: 'Price difference format',
  },
  applyFilters: {
    id: 'bo_sellers-opportunities-pricing-filters-apply_filters',
    defaultMessage: 'Apply filters',
  },
  resetFilters: {
    id: 'bo_sellers-opportunities-pricing-filters-reset_filters',
    defaultMessage: 'Reset filters',
  },
  showMoreFilters: {
    id: 'bo_sellers-opportunities-pricing-filters-show_more_filters',
    defaultMessage: 'Show more filters',
  },
  showLessFilters: {
    id: 'bo_sellers-opportunities-pricing-filters-show_less_filters',
    defaultMessage: 'Show less filters',
  },
  filter: {
    id: 'bo_sellers-opportunities-pricing-filters-filter',
    defaultMessage: 'Filter',
  },
  viewResults: {
    id: 'bo_sellers-opportunities-pricing-filters-view_results',
    defaultMessage: 'View results',
  },
}
